import { BarChart } from '@mui/icons-material';
import { Box } from '@mui/system';
import { PollRecord } from '../../../../models/Poll';

import { MIN_VOTES_TO_DISPLAY } from '../../Poll';
import PollController from '../../PollController';

interface OptionVotesProps {
    poll: PollRecord;
    option: 1 | 2;
}

const OptionVotes = (props: OptionVotesProps): JSX.Element => {
    const right = props.option === 2;
    const totalVotes =
        props.poll.options[0].votes + props.poll.options[1].votes;
    const classes = 'poll-option-votes' + (right ? ' align-right' : '');

    return (
        <>
            {/* HP6 */}
            {totalVotes >= MIN_VOTES_TO_DISPLAY && (
                <Box className={classes}>
                    <BarChart fontSize='small' />
                    {PollController.numberToShortString(
                        props.poll.options[props.option - 1].votes,
                    )}
                </Box>
            )}
        </>
    );
};

export default OptionVotes;
